export default __webpack_public_path__ + "static/media/app-lineapp.beb818ac.svg";